// Output format: "3 Apr 2023"
export const formatReadableDate = date => {
  if (!date) {
    return '';
  }
  return new Date(date).toLocaleDateString('en-GB', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};